// extracted by mini-css-extract-plugin
module.exports = {"section":"DescriptionSection_section_2H2M6","content":"DescriptionSection_content_3p2Ne"};